const UserTypes = {
  Student: 0,
  Teacher: 1,
  Reviewer: 2,
  SuperAdministrator: 3,
  Guest: 4,
  Administrator: 5,
  Sales: 6,
  SuperSales: 7,
  HomeTeacher: 8,
  Trainer: 9
};

export default UserTypes;